import { PaycodeFilter } from '../models';


// Convert PaycodeFilter to the API request parameters
export function addPaycodeFilter(qs: any, filter: PaycodeFilter) {
  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}
